import { navigateBrowserToLegacyTarget } from '@/router/legacy-route-adapter';
import { pushToast } from '@/ui/toast-store';

interface HeaderBridgeWindow {
  EY_RAPToR_openContactSupport?: () => void;
}

let installed = false;

export function installHeaderBridge(): void {
  if (installed) return;
  installed = true;

  const w = window as unknown as HeaderBridgeWindow;
  w.EY_RAPToR_openContactSupport = () => {

    const result = navigateBrowserToLegacyTarget('apps/STF');
    if (!result.supported) {
      pushToast({ variant: 'info', message: result.reason ?? 'Contact support is not available.' });
    }
  };
}
